/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-31 18:28:18
 **/

import { Properties } from "@/frameworks/libraries/properties";
import { RestAPIError } from "@/frameworks/libraries/restservice";
import { _T } from "@rfice/language";
import { useToast } from "@/frameworks/designStuff/components";
import { useCall } from "@/frameworks/core/API";
import { useConfirm } from "../../useConfirm";

const LOGTAG = "#useSendStatus#";

export default function useSendStatus() {
	const toast = useToast();
	const callAPI = useCall();
	const { confirm } = useConfirm();

	return async (callID: string, state: PushServices.Call.UpdateStatus) => {
		const params = {
			callId: callID,
			callUpdateType: state,
			deviceKey: Properties.browserTabID
		};
		console.debug(LOGTAG, "sendStatus with", params);
		await callAPI.groupCall.update.execute(params).catch((error: RestAPIError) => {
			switch (error.code) {
				case "49001": {
					toast.show({ type: "system", message: _T("장치 정보가 달라 통화 오류가 발생하였습니다.") });
					break;
				}
				case "49704": {
					confirm({
						title: _T("이미 통화 중입니다."),
						useOnlyConfirm: true
					});
					break;
				}
				default: {
					throw error;
				}
			}
		});
	};
}
